import React, {ReactNode} from 'react'
import useNetworkStatus from '../../hooks/useNetworkStatus'
import NoNetworkPage from '../pages/NoNetworkPage'
import {FormattedMessage} from 'react-intl'

interface NetworkDetectorProps {
  children: ReactNode
}

export default function NetworkDetector({children}: NetworkDetectorProps) {
  const {isOnline, wasOffline} = useNetworkStatus()

  // Show reconnected message if was offline and now online
  const [showReconnected, setShowReconnected] = React.useState(false)

  React.useEffect(() => {
    if (isOnline && wasOffline) {
      setShowReconnected(true)
      setTimeout(() => setShowReconnected(false), 4000)
    }
  }, [isOnline, wasOffline])

  // If offline, show no network page
  if (!isOnline) {
    return <NoNetworkPage />
  }

  // If online, show normal content with optional reconnected message
  return (
    <>
      {showReconnected && (
        <div className='reconnected-message'>
          <i className='bi bi-wifi me-2'></i>
          <FormattedMessage id='STATUS.RECONNECTED' defaultMessage='Connected! Back online.' />
        </div>
      )}
      {children}
    </>
  )
}

